import React, { ComponentProps } from "react";

function PersonIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width={26}
      height={27}
      viewBox="0 0 26 27"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5593 8.58002C18.5593 11.6639 16.0866 14.1367 13.0006 14.1367C9.91557 14.1367 7.44189 11.6639 7.44189 8.58002C7.44189 5.49614 9.91557 3.02441 13.0006 3.02441C16.0866 3.02441 18.5593 5.49614 18.5593 8.58002ZM13.0016 24.0243C8.44705 24.0243 4.60156 23.284 4.60156 20.428C4.60156 17.5709 8.47121 16.8569 13.0016 16.8569C17.5571 16.8569 21.4016 17.5972 21.4016 20.4532C21.4016 23.3103 17.5319 24.0243 13.0016 24.0243Z"
      />
    </svg>
  );
}

export default PersonIcon;
